import {Component, Inject, OnInit} from '@angular/core';
import {OrganizationBalance, TransferRequest, TransferRequestRes} from '../../pg-detailed-transaction-report/pg-transaction-view';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ReportingService} from '../../reporting.service';
import {LoaderService} from '../../../shared/loader/loader.service';
import {NGXLogger} from 'ngx-logger';
import {CommonDialogNotificationService} from '../../../shared/common-dialog-notification/common-dialog-notification.service';
import {Router} from '@angular/router';
import {DialogType} from '../../../shared/common-dialog-notification/common.dialog.model';

@Component({
  selector: 'bKash-wallet-balance-dialog',
  styleUrls: ['./dialog.css'],
  templateUrl: './dialog.component.html',
})

export class BKashWalletBalanceDialog implements OnInit {
  message: string;
  organizationBalance: OrganizationBalance[];
  flag: boolean = false;
  dialogTitle: string;
  transfer: string;
  transferFlag: boolean = false;
  transferAmount: string;
  transferType: string;
  transferRequest: TransferRequest;
  transferRequestRes: TransferRequestRes;

  constructor(
    public dialogRef: MatDialogRef<BKashWalletBalanceDialog>,
    private reportingService: ReportingService,
    private loaderService: LoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logger: NGXLogger,
    private dialog: MatDialog,
    private dialogService: CommonDialogNotificationService,
    private router: Router) {
  }

  ngOnInit() {
    this.message = this.data.message;
    this.transfer = this.data.transfer;
    this.dialogTitle = this.data.dialogTitle;
    if (this.message === 'success') {
      this.organizationBalance = this.data.organizationBalance;
      this.flag = true;
    }
    if (this.transfer === 'transfer') {
      this.transferFlag = true;
    }
    this.transferRequest = new TransferRequest();
    this.transferRequestRes = new TransferRequestRes();
  }

  close(): void {
    //this.logger.debug('Wallet-Balance/Disburse/transfer dialog closed');
    this.dialogRef.close(true);
  }

  confirmTransfer(transferAmount: string, transferType: string) {
    this.close();
    this.loaderService.show();
    this.transferRequest.amount = transferAmount.trim();
    this.transferRequest.transferType = transferType.trim();
    this.transferRequest.currency = 'BDT';
    this.reportingService.transferRequest(this.transferRequest).subscribe((data) => {
      this.transferRequestRes = data.body as TransferRequestRes;
      this.loaderService.hide();
      if (this.transferRequestRes.transactionStatus == null && this.transferRequestRes.errorMessage == null) {
        //this.logger.debug('transfer request failed');
        this.dialogService.open(DialogType.INFO, 'Request Failed', 'Intra Account Transfer');

      } else if (this.transferRequestRes.transactionStatus == null) {
        //this.logger.debug('transfer request failed due to... ', this.transferRequestRes.errorMessage);
        this.dialogService.open(DialogType.INFO, this.transferRequestRes.errorMessage, 'Intra Account Transfer');
      } else if (this.transferRequestRes.transactionStatus == 'Completed') {
        //this.logger.debug('transfer request success ....');
        this.dialogService.open(DialogType.INFO, this.transferRequestRes.transactionStatus, 'Intra Account Transfer');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/report/disburse-list/dialog/bkash.wallet.balance.dialog.component.ts